/**
 * Creates a sort function for a Document, based on a field.
 * @param {string} field The field to sort on
 * @param {function} valueOf An (optional) function to calculate a derived value for this field, by default
 * It's just doc['field'], but you can create a function that uses any or multiple fields.
 * @returns {function} A sort function suitable for use in Array.sort
 */
export const getSort = (field, valueOf = (doc) => doc[field]) => (a, b) => {
    const va = valueOf(a);
    const vb = valueOf(b);
    return va > vb ? 1 : va === vb ? 0 : -1;
};
/**
 * Composes multiple sorts hierarchically
 * @param {function[]} sorts A list of sorts
 * @returns {function} A composed sort function
 */
export const composeSorts = (...sorts) => (a, b) => {
    for (const sort of sorts) {
        const order = sort(a, b);
        if (order !== 0) {
            // Keep iterating if order === 0, otherwise return current order
            return order;
        }
    }
    // We got all the way through with every level being equal, so we are truly equal
    return 0;
};
/**
 * Reverse the order of a sort
 * @param {function} sort The sort to reverse.
 * @returns {function} A reversed sort
 */
export const reverseSort = (sort) => (a, b) => (0 - sort(a, b));
